module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#photostory",
      toString: function () {
        return this.url;
      }
    }